import { render, staticRenderFns } from "./index.vue?vue&type=template&id=56d2ea45&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d2ea45",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2022/sdSdm/sdSdmAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56d2ea45')) {
      api.createRecord('56d2ea45', component.options)
    } else {
      api.reload('56d2ea45', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=56d2ea45&scoped=true&", function () {
      api.rerender('56d2ea45', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/active/yinshuiji/index.vue"
export default component.exports